export const coapplicantKeys = [
  'coapplicantFirstName',
  'coapplicantLastName',
  'coapplicantEmail',
  'coapplicantPhone',
  'coapplicantRelationship',
  'coapplicantVisaSubClass',
  'coapplicantVisaExpiryDate',
  'coapplicantLivingTogether',
  'coapplicantCountry',
  'coapplicantCitizenship',
  'coapplicantPermanentResident',
  'coapplicantCurrentResidentalStatus',
  'coapplicantRentExpense',
  'coapplicantFrequencyOfRent',
  'coapplicantIsTheResidentialPlaceMortgaged',
  'coapplicantResidentalOtherSpecification',

  'coapplicantNonPropertyLoan',
  'coapplicantIncomeSource',
  'coapplicantCreditCardCurrency',
  'coapplicantCreditCardLimit',
  'coapplicantJobStartMonth',
  'coapplicantJobStartYear',
  'coapplicantOccupation',
  'coapplicantSalaryCurrency',
  'coapplicantCompanySalaryCurrency',
  'coapplicantBaseSalary',
  'coapplicantSalaryFrequency',
  'coapplicantReceiveAllowanceIncome',
  'coapplicantAllowanceIncome',
  'coapplicantAllowanceFrequency',
  'coapplicantTypeOfAllowanceIncome',
  'coapplicantReceiveCommissionIncome',
  'coapplicantCommissionFrequency',
  'coapplicantCommissionYears',
  'coapplicantCommissionIncome',
  'coapplicantReceiveAnnualCashBonus',
  'coapplicantThisYearAnnualCashBonus',
  'coapplicantLastYearAnnualCashBonus',

  'coapplicantReceiveStockUnit',
  'coapplicantThisYearStockOptions',
  'coapplicantLastYearStockOptions',

  'coapplicantIndustry',
  'coapplicantOperationStartMonth',
  'coapplicantOperationStartYear',

  'coapplicantThisYearPersonalNetIncomeAfterTaxes',
  'coapplicantLastYearPersonalNetIncomeAfterTaxes',

  'coapplicantOwnershipPercentage',
  'coapplicantThisYearCompanyNetIncomeAfterTaxes',
  'coapplicantLastYearCompanyNetIncomeAfterTaxes',

  'coapplicantVisaSubClass',
  'coapplicantVisaExpiryDate',

  'coapplicantThisYearPersonalNetIncomeBeforeTaxes',
  'coapplicantLastYearPersonalNetIncomeBeforeTaxes',

  'coapplicantThisYearCompanyNetIncomeBeforeTaxes',
  'coapplicantLastYearCompanyNetIncomeBeforeTaxes',

  'coapplicantNonPropertyLoanType1',
  'coapplicantNonPropertyLoanCurrency1',
  'coapplicantNonPropertyLoanBalance1',
  'coapplicantNonPropertyLoanRepaymentTerm1',
  'coapplicantNonPropertyLoanRepaymentSum1',
  'coapplicantNonPropertyLoanRepaymentFrequency1',

  'coapplicantNonPropertyLoanType2',
  'coapplicantNonPropertyLoanCurrency2',
  'coapplicantNonPropertyLoanBalance2',
  'coapplicantNonPropertyLoanRepaymentTerm2',
  'coapplicantNonPropertyLoanRepaymentSum2',
  'coapplicantNonPropertyLoanRepaymentFrequency2',

  'coapplicantNonPropertyLoanType3',
  'coapplicantNonPropertyLoanCurrency3',
  'coapplicantNonPropertyLoanBalance3',
  'coapplicantNonPropertyLoanRepaymentTerm3',
  'coapplicantNonPropertyLoanRepaymentSum3',
  'coapplicantNonPropertyLoanRepaymentFrequency3',

  'coapplicantNonPropertyLoanType4',
  'coapplicantNonPropertyLoanCurrency4',
  'coapplicantNonPropertyLoanBalance4',
  'coapplicantNonPropertyLoanRepaymentTerm4',
  'coapplicantNonPropertyLoanRepaymentSum4',
  'coapplicantNonPropertyLoanRepaymentFrequency4',

  'coapplicantNonPropertyLoanType5',
  'coapplicantNonPropertyLoanCurrency5',
  'coapplicantNonPropertyLoanBalance5',
  'coapplicantNonPropertyLoanRepaymentTerm5',
  'coapplicantNonPropertyLoanRepaymentSum5',
  'coapplicantNonPropertyLoanRepaymentFrequency5',
];

export const nonPropertyLoanKeys = [
  'nonPropertyLoanType1',
  'nonPropertyLoanCurrency1',
  'nonPropertyLoanBalance1',
  'nonPropertyLoanRepaymentTerm1',
  'nonPropertyLoanRepaymentSum1',

  'nonPropertyLoanType2',
  'nonPropertyLoanCurrency2',
  'nonPropertyLoanBalance2',
  'nonPropertyLoanRepaymentTerm2',
  'nonPropertyLoanRepaymentSum2',

  'nonPropertyLoanType3',
  'nonPropertyLoanCurrency3',
  'nonPropertyLoanBalance3',
  'nonPropertyLoanRepaymentTerm3',
  'nonPropertyLoanRepaymentSum3',

  'nonPropertyLoanType4',
  'nonPropertyLoanCurrency4',
  'nonPropertyLoanBalance4',
  'nonPropertyLoanRepaymentTerm4',
  'nonPropertyLoanRepaymentSum4',

  'nonPropertyLoanType5',
  'nonPropertyLoanCurrency5',
  'nonPropertyLoanBalance5',
  'nonPropertyLoanRepaymentTerm5',
  'nonPropertyLoanRepaymentSum5',
];

export const coapplicantNonPropertyLoanKeys = [
  'coapplicantNonPropertyLoanType1',
  'coapplicantNonPropertyLoanCurrency1',
  'coapplicantNonPropertyLoanBalance1',
  'coapplicantNonPropertyLoanRepaymentTerm1',
  'coapplicantNonPropertyLoanRepaymentSum1',

  'coapplicantNonPropertyLoanType2',
  'coapplicantNonPropertyLoanCurrency2',
  'coapplicantNonPropertyLoanBalance2',
  'coapplicantNonPropertyLoanRepaymentTerm2',
  'coapplicantNonPropertyLoanRepaymentSum2',

  'coapplicantNonPropertyLoanType3',
  'coapplicantNonPropertyLoanCurrency3',
  'coapplicantNonPropertyLoanBalance3',
  'coapplicantNonPropertyLoanRepaymentTerm3',
  'coapplicantNonPropertyLoanRepaymentSum3',

  'coapplicantNonPropertyLoanType4',
  'coapplicantNonPropertyLoanCurrency4',
  'coapplicantNonPropertyLoanBalance4',
  'coapplicantNonPropertyLoanRepaymentTerm4',
  'coapplicantNonPropertyLoanRepaymentSum4',

  'coapplicantNonPropertyLoanType5',
  'coapplicantNonPropertyLoanCurrency5',
  'coapplicantNonPropertyLoanBalance5',
  'coapplicantNonPropertyLoanRepaymentTerm5',
  'coapplicantNonPropertyLoanRepaymentSum5',
];
